import {
  getPmSectionData,
  getPmSectionError,
  getPmSectionProcessing,
  getPmSectionType,
} from '../../../pm-section/index'
import { selectSectionsIds } from './selectSectionsIds'

function sectionCanRender (options = {}) {
  const { pmSection = Map(), sectionId } = options
  const sectionProcessing = getPmSectionProcessing({ pmSection, sectionId })
  const sectionError = getPmSectionError({ pmSection, sectionId })
  const sectionData = getPmSectionData({ pmSection, sectionId })
  // If we don't have any section state don't render
  return sectionProcessing || sectionData || sectionError
}

export function selectReadyToRenderSections (state) {
  const sectionIds = selectSectionsIds(state)
  const { pmSection } = state

  const readySectionIds = sectionIds.filter((sectionId) => {
    // If we don't have any section data or any type to render don't
    // render a section component
    const sectionType = getPmSectionType({ pmSection, sectionId })
    const canRender = sectionCanRender({ pmSection, sectionId })
    const shouldInclude = sectionType && canRender

    return shouldInclude
  })

  return readySectionIds
}

export default selectReadyToRenderSections
